import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const productsJswStorageManagementRoute: InvariantJiraRoute = {
	name: 'products-jsw-storage-management',
	path: '/jira/settings/products/jira-software-configuration/storage-management',
	exact: true,
};
